import { FormResult } from '../../../types/shared';

import { InputValue } from '../../organisms/calculator/Calculator.types';

// Return a calculation that can be made with eval when validated based on calculation given in CMS and input values.
const parseCalculationByInputValues = (
  calculation: string,
  inputValues: InputValue[]
): string => {
  let formattedCalculation = calculation;

  // Check if calculation is empty, or if there is no input.
  if (!calculation.length || !inputValues.length) {
    return '';
  }

  const foundValues = inputValues.filter((item) =>
    calculation.includes(item.id)
  );

  // When input values are found in given calculation, apply them.
  if (foundValues.length) {
    foundValues.forEach((item) => {
      const regex = new RegExp(item.id, 'g'); // Create a global regex for the item.id
      formattedCalculation = formattedCalculation.replace(regex, item.value);
    });
  } else {
    formattedCalculation = '';
  }

  // Check if the calculation is complete / valid;
  if (formattedCalculation.includes('calculationId')) {
    formattedCalculation = '';
  }

  return formattedCalculation;
};

// Based on the calculated value based on the context type setting.
const getParsedCalculationOutcome = (
  placeholder: string,
  calculationResult: string,
  contextType: FormResult['contextType']
): string => {
  // Either the calculated result or the placeholder.
  const value = calculationResult || placeholder;

  switch (contextType) {
    case 'currency':
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
      })
        .format(Number(value))
        .replace(' ', '');
    case 'percentage':
      return `${value}%`;
    default:
      return '';
  }
};

export { getParsedCalculationOutcome, parseCalculationByInputValues };
